module.exports = __webpack_public_path__ + "static/media/laptop.2d3e27cf.svg";